// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5b-0";
export var startPickingButton = "_5b-1";